import { atom } from 'recoil';

// isLoading をグローバルで管理
export const loadingState = atom<boolean>({
  key: 'loadingState',
  // 初期状態は false（ロードしていない）
  default: false, 
});
